import type { Theme } from "expo-router/react-navigation";
import { ThemeContext } from "expo-router/react-navigation";
import { useContext } from "react";

import type { CustomTheme } from "../types";

const isCustomTheme = (theme: Theme | undefined): theme is CustomTheme => {
  return (
    theme !== undefined &&
    typeof theme === "object" &&
    "colors" in theme &&
    "info" in theme.colors &&
    "success" in theme.colors &&
    "warning" in theme.colors &&
    "danger" in theme.colors &&
    "sectionBackground" in theme.colors &&
    "tableRowHover" in theme.colors &&
    "menuA" in theme.colors &&
    "menuB" in theme.colors &&
    "menuD" in theme.colors
  );
};

export const useCustomTheme = () => {
  const theme = useContext(ThemeContext);

  if (!isCustomTheme(theme)) {
    throw new Error(
      "useCustomTheme must be used within a ThemeProvider or NavigationContainer with a theme",
    );
  }

  return theme;
};
